module.exports = __webpack_public_path__ + "size3.png";